import React from 'react';
import { SearchState } from './reducers/searchReducer';
import { publishNoSearchResult, publishSearchProductImpressionEvents } from '../../services/analytics';

const useSearchAnalytics = (state: SearchState) => {
    const { isLoading, page, visibleProductTiles } = state;

    const pageRef = React.useRef(page);

    React.useEffect(() => {
        let canceled = false;

        if (visibleProductTiles.length) {
            (async function publishImpressions() {
                try {
                    // If we start by loading for example page=3, send 3 batch reports, 1 per page
                    // If we click "Load more" and proceed from page=3 to page=4, report page 4 only
                    const startPage = pageRef.current < page ? page : 1;

                    for await (const _result of publishSearchProductImpressionEvents(state, startPage))
                        if (canceled) break;
                } catch (e) {
                    console.error(e); // analytics failure shouldn't affect user experience
                }
            })();
        }

        pageRef.current = page;

        return function cleanup() {
            canceled = true;
        };
    }, [visibleProductTiles]);

    React.useEffect(() => {
        if (!isLoading && !visibleProductTiles.length) {
            (async function publishNoResult() {
                try {
                    publishNoSearchResult(state);
                } catch (e) {
                    console.error(e); // analytics failure shouldn't affect user experience
                }
            })();
        }
    }, [visibleProductTiles, isLoading]);
};

export { useSearchAnalytics };
